import React, { useEffect, useState } from "react";
import Byod from "./Byod";
import ByodMonarch from "./ByodMonarch";
import { useGlobalData } from "hooks";
function Wrapper(props) {
  const [isNewBYOD, setIsNewBYOD] = useState(false);
  const { sessionCartData } = useGlobalData({
    skipSessionCart: true,
  });
  const isfromAgentLinkPage = sessionCartData?.apiResponse?.prospectFlowData?.fromAgentLinkPage || false;
  useEffect(() => {
     setIsNewBYOD(!isfromAgentLinkPage);
  }, [isfromAgentLinkPage])
  return (
    <>
      {isNewBYOD ?
        <ByodMonarch category={props} /> : <Byod category={props} />}
    </>
  );
}

export default Wrapper;